import { Component, OnInit, Input, ViewChild, EventEmitter, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {MenuItem} from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-add-edit-user',
  templateUrl: './add-edit-user.component.html',
  styleUrls: ['./add-edit-user.component.scss'],
  providers: [MessageService]
})
export class AddEditUserComponent implements OnInit {

  @Input() user;
  @Input() users;
  @Input() partnerId;
  @Input() cyclistView : boolean;
  @Input() singleBike : boolean = false;
  @Input() bikeId;
  @Output() update = new EventEmitter();
  @Input() technicians; //Use this to when linking a technician to see if they exist before recreating them.

  public activeItem : MenuItem;
  public selectedTab : number;
  public tabItems : MenuItem[];



  public customer: any;

  public userTab : MenuItem[] = [
    {label: this.translate.instant('bikeshop.modal.add_edit_user.user'), icon: '', command:()=>{this.selectedTab = 0}}
  ];

  public userTechnicianTab : MenuItem[] = [
    {label: this.translate.instant('bikeshop.modal.add_edit_user.user'), icon: '', command:()=>{this.selectedTab = 0}},
    {label: this.translate.instant('bikeshop.modal.add_edit_user.technician'), icon: '', command:()=>{this.selectedTab = 1}},
    {label: this.translate.instant('bikeshop.modal.add_edit_user.technician_work_hours'), icon: '', command:()=>{this.selectedTab = 2}}  
  ];

  public technicianTab : MenuItem[] = [
    {label: this.translate.instant('bikeshop.modal.add_edit_user.technician'), icon: '', command:()=>{this.selectedTab = 1}},
    {label: this.translate.instant('bikeshop.modal.add_edit_user.technician_work_hours'), icon: '', command:()=>{this.selectedTab = 2}}  
  ];

  public cyclistTab : MenuItem[] = [
    {label: this.translate.instant('bikeshop.modal.add_edit_user.user'), icon: '', tab: 5, command:()=>{this.selectedTab = 5}},
    {label: this.translate.instant('bikeshop.modal.add_edit_user.bikes'), icon: '', tab: 3, command:()=>{this.selectedTab = 3}},
    { label: this.translate.instant('bikeshop.rentals.booking.address'), icon: '', tab: 6, command:()=>{this.selectedTab = 6}}  
  ];

  public newCyclistTab : MenuItem[] = [
    {label: this.translate.instant('bikeshop.modal.add_edit_user.cyclist'), icon: '', command:()=>{this.selectedTab = 4}}
  ];

  constructor(
    public modal : NgbActiveModal,
    public messageService : MessageService,
    private translate : TranslateService
  ) {
    
  }

  ngOnInit() {
    this.cyclistView = this.cyclistView === undefined ? false : this.cyclistView;
    this.buildTabs();   
  }

  buildTabs(){
    if (this.cyclistView && this.user.ID) {
      this.tabItems = this.cyclistTab;
      this.activeItem = this.tabItems[0];
      this.selectedTab = 5;
    }else if(this.cyclistView && !this.user.ID){
      this.tabItems = this.newCyclistTab;
      this.activeItem = this.tabItems[0];
      this.selectedTab = 4;
    }else if(this.user.ID && this.user.Email && this.user.Technician && this.user.Technician.ID){
      this.tabItems = this.userTechnicianTab;
      this.activeItem = this.tabItems[0];
      this.selectedTab = 0;
    }else if(!this.user.ID || (this.user.Email && this.user.TechnicianID===0)){
      this.tabItems = this.userTab;
      this.activeItem = this.tabItems[0];
      this.selectedTab = 0;
    }else{
      this.tabItems = this.technicianTab;
      this.activeItem = this.tabItems[0];
      this.selectedTab = 1;
    }
  }

  updateUser(user){
    this.user = user;
    this.buildTabs();
    this.update.emit();
  }



  showTabs(tab) {
    console.log(tab);
    this.selectedTab = tab.tab;
  }

  checkifActive(tab)
  {
    return (tab.tab === this.selectedTab)
  }

}
